import { ColorType } from "@/web-client/api";

export interface IColor {
  id: ColorType;
  name: string;
  style: string;
}

export const Colors: IColor[] = [
  { id: ColorType.RED, name: "レッド", style: "#f00" },
  { id: ColorType.ORANGE, name: "オレンジ", style: "#fa0" },
  { id: ColorType.YELLOW, name: "イエロー", style: "#ff0" },
  { id: ColorType.GREEN, name: "グリーン", style: "#0f0" },
  { id: ColorType.BLUE, name: "ブルー", style: "#00f" },
  { id: ColorType.PURPLE, name: "パープル", style: "#90f" },
  { id: ColorType.PINK, name: "ピンク", style: "#f69" },
  { id: ColorType.DARK_BROWN, name: "ダークブラウン", style: "#644" },
  { id: ColorType.BROWN, name: "ブラウン", style: "#a43" },
  { id: ColorType.BEIGE, name: "ベージュ", style: "#cb9" },
  { id: ColorType.WHITE, name: "ホワイト", style: "#fff" },
  { id: ColorType.GRAY, name: "グレー", style: "#aaa" },
  { id: ColorType.BLACK, name: "ブラック", style: "#000" },
  {
    id: ColorType.SILVER,
    name: "シルバー",
    style:
      "linear-gradient(0deg, #757575 0%, #9E9E9E 45%, #E8E8E8 70%, #9E9E9E 85%, #757575 90% 100%)",
  },
  {
    id: ColorType.GOLD,
    name: "ゴールド",
    style:
      "linear-gradient(0deg, #B67B03 0%, #DAAF08 45%, #FEE9A0 70%, #DAAF08 85%, #B67B03 90% 100%)",
  },
  {
    id: ColorType.CLEAR,
    name: "クリア",
    style:
      "linear-gradient(180deg, rgba(255,255,255,0.5) 0%, rgba(176,235,255,1) 100%)",
  },
  {
    id: ColorType.MULTI,
    name: "マルチ",
    style:
      "linear-gradient(90deg, rgba(180,58,84,1) 0%, rgba(29,137,253,1) 50%, rgba(252,208,69,1) 100%)",
  },
];
export default Colors;
